import z from "zod";

export const assignUserCrewSchema = z.object({
	assignmentId: z.string().optional(),
	userId: z.string(),
	assignmentRanking: z.number().optional(),
});

export type AssignUserCrewSchema = z.infer<typeof assignUserCrewSchema>;
